import http from './http';

export interface MedicalPOAPreferencesData {
  id?: string;
  primaryAgentName: string;
  primaryAgentRelationship: string;
  primaryAgentPhone: string;
  primaryAgentEmail: string;
  alternateAgentName?: string;
  alternateAgentRelationship?: string;
  alternateAgentPhone?: string;
  alternateAgentEmail?: string;
  documentLocation: string;
  attorneyContact?: string;
  specificInstructions?: string;
  familyInformed: boolean;
  lastUpdated: string;
  isLocked?: boolean;
}

class MedicalPOAPreferencesService {
  async createMedicalPOAPreferences(data: Omit<MedicalPOAPreferencesData, 'id'>): Promise<MedicalPOAPreferencesData> {
    const response = await http.post('/api/medical-poa-preferences', data);
    return response.data.data || response.data;
  }

  async updateMedicalPOAPreferences(id: string, data: Partial<MedicalPOAPreferencesData>): Promise<MedicalPOAPreferencesData> {
    const response = await http.patch(`/api/medical-poa-preferences/${id}`, data);
    return response.data.data || response.data;
  }

  async getMedicalPOAPreferencesById(id: string): Promise<MedicalPOAPreferencesData> {
    const response = await http.get(`/api/medical-poa-preferences/${id}`);
    return response.data.data || response.data;
  }

  async getAllMedicalPOAPreferences(): Promise<MedicalPOAPreferencesData[]> {
    const response = await http.get('/api/medical-poa-preferences');
    return response.data.data || response.data;
  }

  async deleteMedicalPOAPreferences(id: string): Promise<void> {
    await http.delete(`/api/medical-poa-preferences/${id}`);
  }

  async lockMedicalPOAPreferences(id: string): Promise<void> {
    await http.post(`/api/medical-poa-preferences/${id}/lock`);
  }

  async unlockMedicalPOAPreferences(id: string, emails: string[]): Promise<void> {
    await http.post(`/api/medical-poa-preferences/${id}/unlock`, { emails });
  }

  async getMedicalPOAPreferencesAccessGrants(id: string): Promise<any[]> {
    const response = await http.get(`/api/medical-poa-preferences/${id}/access-grants`);
    return response.data.data || response.data;
  }
}

export const medicalPOAPreferencesService = new MedicalPOAPreferencesService();